export default __webpack_public_path__ + "static/media/language.699d2da5.svg";